import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals, { sendToAnalytics } from './reportWebVitals';
import ReactGA from "react-ga4";

// Initialize Google Analytics 4
ReactGA.initialize("G-FW4JXM19DK");

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Send Core Web Vitals to Google Analytics
reportWebVitals(sendToAnalytics);
